import { FC, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { useOrder } from "../../hooks/useOrder";

import PixImg from "../../assets/images/pix.png";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";
import moment from "moment";

import styles from "./newChoosePayment.module.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import {
  CustomerType,
  MeasureType,
  OrderAddress,
  OrderContext,
  ProductType,
} from "../../contexts/OrderContext";
import { PluginspaceResponseType } from "../../contexts/PluginspaceContext";
import { ModalDelivery } from "../../components/ModalDelivery";
import Swal from "sweetalert2";
import { cpfCnpjNoMask, cpfMask, rtcToText } from "../../functions/mask";
import { ModalTerms } from "../../components/ModalTerms";
import { Input } from "../../components/Input/Input";
import Switch from "../../components/Switch/Switch";
// icones
import visaLogo from "../../assets/images/visa.svg";
import ticketLogo from "../../assets/images/ticket.svg";
import masterCardLogo from "../../assets/images/masterCard.svg";
import redeLogo from "../../assets/images/rede.svg";
import aleloLogo from "../../assets/images/alelo.svg";
import americaExpressLogo from "../../assets/images/americanExpress.svg";
import eloLogo from "../../assets/images/elo.svg";
import hiperCardLogo from "../../assets/images/hipercard.svg";
import maestroLogo from "../../assets/images/maestro.svg";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import { SumaryOrder } from "../../components/sumaryOrder/sumaryOrder.module";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import { calculatePriceFractionalToProduct } from "../../functions/price_functions";
import CardPaymentDiscount from "../../components/cardPaymentDiscount/cardPaymentDiscount";
import ModalSelectInstallment from "../../components/ModalSelectInstallment";
import { useToast } from "../../hooks/useToast";
import { useDiscount } from "../../hooks/useDiscount";

type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

type ProcessorWalletType = {
  externalCode: string;
  processorId: string;
};

type WalletType = {
  id: string;
  code: string;
  logo: string;
  name: string;
  processorDigitalWallets: ProcessorWalletType[];
};

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures?: MeasureType;
  }>;
};

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

export type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: string;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
  plugintemplateId: number;
  ableDiscount: boolean;
  discountValue: string;
  typeDiscount: string | undefined;
  installment?: number;
  installmentValue?: number;
};

const NewChoosePayment: FC<any> = () => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const orderContext = useOrder();
  const { getToken, getThisPluginspace, registerAccess, pluginspace } =
    usePluginspace();
  const { freight, totalValue, totalValueWithoutDiscount, setPaymentDiscountFunction, removePaymentDiscountFunction } = useOrder();
  const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
  const [cpfNote, setCpfNote] = useState("");
  const [useCpfNote, setUseCpfNote] = useState(1);
  const [paymentMethods, setPaymentMethods] = useState<Array<PluginconfigType>>(
    []
  );
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const { openToast } = useToast()

  const [openModalInstallment, setOpenModalInstallment] = useState(false);
  const [paymentSelected, setPaymentSelected] =
    useState<IntegrationType | null>(null);
  const [installments, setInstallments] = useState<number>(1);

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [gatewayIdSelected, setGatewayIdSelected] = useState(0);

  const [customer, setCustomer] = useState<CustomerType | any>();
  const [type, setType] = useState("");
  const [typePayment, setTypePayment] = useState("");
  const [wallets, setWallets] = useState<WalletType[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [momentType, setMomentType] = useState("before");
  const [paymentsAfter, setPaymentsAfter] = useState<IntegrationType[]>([]);
  const [selectedPaymentAfter, setSelectedPaymentAfter] =
    useState<IntegrationType | null>(null);
  const [typeAfter, setTypeAfter] = useState("card");
  const [paymentMoney, setPaymentMoney] = useState("");
  const [total, setTotal] = useState(0);
  const [havePaymentOnline, setHavePaymentOnline] = useState(false);
  const [isCounter, setIsCounter] = useState(false);

  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [needChanges, setNeedChanges] = useState(false);

  const [paymentDiscount, setPaymentDiscount] = useState<{
    typeDiscount: string,
    discountValue: string
  } | null>(null);

  const [paymentsAfterAble, setPaymentsAfterAble] = useState({
    ableCredit: false,
    ableDebit: false,
    ableAlimentation: false,
    ablePix: false,
    ableMoney: false,
    ableOthers: false,
  });

  /*Variavel utilizada para saber se tem o plugin do motor de desconto */
  const [ninegridMotorAble, setNinegridMotorAble] = useState(false);


  const [nameTabeWithdrawal, setNameTabeWithdrawal] = useState<string | null>(
    null
  );

  const [codePlanSelected, setCodePlanSelected] = useState<string>();
  const discountContext = useDiscount()

  useEffect(() => {
    registerAccess("order");
    getConfig();
    const isCounterStorage = localStorage.getItem("counter_number");
    setIsCounter(isCounterStorage ? true : false);
    discountContext.setPaymentDiscount('', 0, 0)
  }, []);

  async function loadOrder() {
    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);
    } else {
      const customerStorage = await orderContext.getCustomer();
      const typeStorage = await orderContext.getType();
      const orderAddressStorage = await orderContext.getOrderAddress();
      orderContext.setCpfInNote("");
      const totalValue = await orderContext.getTotalValue();
      const freight = await orderContext.getFreight();
      setTotal(totalValue + freight);
      setCpfNote(customerStorage.cpf);
      setCustomer(customerStorage);
      setType(typeStorage);
      setOrderAddress(orderAddressStorage);
      await getPaymentMethods(0);
    }
  }

  async function getSellerInfo() {
    const sellerCPF = await orderContext.getSellerCpfCnpj();

    if (sellerCPF) {
      await api
        .post(
          "api/users/seller",
          {
            cpf: sellerCPF,
          },

          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setSellerInfo(response.data.data[0]);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao encontrar loja",
          });
        });
    }
  }

  async function getConfig() {
    localStorage.removeItem("qrcodePixPayment");
    setLoading(true);
    setLoadingHeader(true);
    const findedConfig: ConfigType | void = await getAppConfig();
    setLoadingHeader(false);
    setConfig(findedConfig);
    await orderContext.synchronizeContextToStorage();
    const totalValues = await orderContext.totalValueOrder();
    await orderContext.removePaymentDiscountFunction();
    orderContext.setTotalValue(totalValues.total);
    orderContext.setDiscountGeneral(0);

    await loadOrder();
    if (findedConfig)
      await getOperators(findedConfig.content.pdv.gatewayDeliveryId);

    await getSellerInfo();
    await verifyNinegridProm();
    setLoading(false);
  }

  async function getOperators(gatewayPaymentAfter: number) {
    try {
      const pluginspace = await getThisPluginspace();
      if (pluginspace) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: pluginspace.hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
        if (
          resIntegration.data &&
          resIntegration.data.data &&
          resIntegration.data.data.data &&
          resIntegration.data.success
        ) {
          setPaymentsAfter(
            resIntegration.data.data.data.filter(
              (pymt: IntegrationType) =>
                pymt.plugintemplateId === 44 &&
                pymt.pluginconfigId === gatewayPaymentAfter
            )
          );
        } else {
          setPaymentsAfter([]);
        }
      } else {
        setPaymentsAfter([]);
      }
    } catch (error) {
      return;
    }
  }

  async function getPaymentMethods(locationId: number) {
    const locationIdToSend = locationId
      ? locationId
      : await orderContext.getLocationId();
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintypeId: 14,
          locationId: locationIdToSend ? locationIdToSend : null,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const dataPayments = response.data.data.filter(
          (pluginconfigs: PluginconfigType) =>
            pluginconfigs.content.able === "1" ||
            pluginconfigs.content.ableCard === "1" ||
            pluginconfigs.content.ableDebit === "1" ||
            pluginconfigs.content.ablePix === "1" ||
            pluginconfigs.content.pix === "1" ||
            pluginconfigs.content.ableAlimentation === "1" ||
            pluginconfigs.content.ableOthers === "1" ||
            pluginconfigs.content.ableMoney === "1"
        );

        response.data.data.forEach((config: any) => {
          if (config.content.paymentWithdrawalTabCustom) {
            setNameTabeWithdrawal(config.content.paymentWithdrawalTabCustom);
            return;
          }
        });

        const configStore = await getAppConfig();
        if (configStore && configStore.content && configStore.content.pdv) {
          const paymentDelivery = response.data.data.find(
            (pluginconfig: PluginconfigType) =>
              pluginconfig.id === configStore.content.pdv.gatewayDeliveryId
          );
          if (paymentDelivery && paymentDelivery.content) {
            if (paymentDelivery.content.pix)
              paymentDelivery.content.ablePix = paymentDelivery.content.pix;
            setPaymentsAfterAble({
              ableCredit:
                paymentDelivery.content.able &&
                  paymentDelivery.content.able === "1"
                  ? true
                  : false,
              ableDebit:
                paymentDelivery.content.ableDebit &&
                  paymentDelivery.content.ableDebit === "1"
                  ? true
                  : false,
              ableAlimentation:
                paymentDelivery.content.ableAlimentation &&
                  paymentDelivery.content.ableAlimentation === "1"
                  ? true
                  : false,
              ablePix:
                paymentDelivery.content.ablePix &&
                  paymentDelivery.content.ablePix === "1"
                  ? true
                  : false,
              ableMoney:
                paymentDelivery.content.ableMoney &&
                  paymentDelivery.content.ableMoney === "1"
                  ? true
                  : false,
              ableOthers:
                paymentDelivery.content.ableOthers &&
                  paymentDelivery.content.ableOthers === "1"
                  ? true
                  : false,
            });
          }
          const paymentsOnline = dataPayments.filter(
            (pluginconfigs: PluginconfigType) =>
              pluginconfigs.plugintemplateId.id !== 44 &&
              (pluginconfigs.id === configStore.content.pdv.gatewayId ||
                pluginconfigs.id === configStore.content.pdv.gatewayPixId)
          );

          setHavePaymentOnline(paymentsOnline && paymentsOnline.length > 0);
        }
        setPaymentMethods(dataPayments);
        const paymentHub = dataPayments.find(
          (pluginconfigs: PluginconfigType) =>
            pluginconfigs.plugintemplateId.id === 25
        );
        const pluginspaceData: void | PluginspaceResponseType =
          await getThisPluginspace();
        if (paymentHub) {
          await api
            .post(
              `/api/totvshub/listWalletPay`,
              {
                pluginspaceId: pluginspaceData ? pluginspaceData.id : 0,
                gatewayId: paymentHub.id,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            )
            .then((responseWallet) => {
              const walletsResponse = responseWallet.data.paymentMethods;
              setWallets(walletsResponse);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function choosePayment() {

    if (momentType === "after") {
      if (!selectedPaymentAfter) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Selecione um meio de pagamento.",
        });
        return;
      }
      orderContext.setIntegrationPlan({
        codePay: selectedPaymentAfter.codePay,
        codePlan:
          selectedPaymentAfter.paymentPlans && codePlanSelected
            ? codePlanSelected
            : selectedPaymentAfter.paymentPlans?.[0]?.codePlan ?? 0,
        nameGateway: selectedPaymentAfter.nameGateway,
        nameBrand: selectedPaymentAfter.brand,
        typePayment: typeAfter,
        paymentItemData: selectedPaymentAfter,
      });
      if (
        selectedPaymentAfter.cardOperator === 100 &&
        (!paymentMoney ||
          parseFloat(total.toFixed(2)) > parseFloat(paymentMoney))
      ) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "O pagamento em dinheiro deve ser maior ou igual ao valor da compra.",
        });
        return;
      }
      orderContext.setChangePayment(
        parseFloat((parseFloat(paymentMoney) - total).toFixed(2))
      );
    } else {
      orderContext.setChangePayment(0);
    }
    await orderContext.totalValueOrder();
    setLoading(true);
    if (cpfNote === "" || !cpfNote || cpfNote.includes("_")) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um CPF válido na nota",
      });
      setLoading(false);
      return;
    }

    if (!gatewayIdSelected) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um meio de pagamento",
      });
      setLoading(false);
      return;
    }

    const paymentTypeStorage = await orderContext.getPaymentType();

    if (useCpfNote === 1) {
      orderContext.setCpfInNote(cpfNote);
    } else {
      orderContext.setCpfInNote("");
    }
    orderContext.setIsCpfInNote(useCpfNote);

    orderContext.setPaymentType(typePayment);
    orderContext.setTotalValue(total)



    await orderContext.synchronizeContextToStorage();

    if (paymentTypeStorage.includes("card")) {
      setLoading(false);
      navigate(`/${pluginspace_id}/card`);
    } else if (
      paymentTypeStorage.includes("pix") ||
      paymentTypeStorage.includes("shipay") ||
      paymentTypeStorage.includes("wallet")
    ) {
      setLoading(false);

      if (pluginspace.type !== "food") {
        navigate(`/${pluginspace_id}/new-order-finalize`);
      } else {
        navigate(`/${pluginspace_id}/order-finalize`);
      }
    } else if (paymentTypeStorage.includes("delivery-payment")) {
      // await generateCodePayPlanDelivery();
      setLoading(false);

      if (pluginspace.type !== "food") {
        navigate(`/${pluginspace_id}/new-order-finalize`);
      } else {
        navigate(`/${pluginspace_id}/order-finalize`);
      }
    }
  }

  async function chooseBeforePayment(payment: string, paymentId: number) {

    if (momentType === "after") {
      if (!selectedPaymentAfter) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Selecione um meio de pagamento.",
        });
        return;
      }
      orderContext.setIntegrationPlan({
        codePay: selectedPaymentAfter.codePay,
        codePlan:
          selectedPaymentAfter.paymentPlans && codePlanSelected
            ? codePlanSelected
            : selectedPaymentAfter.paymentPlans?.[0]?.codePlan ?? 0,
        nameGateway: selectedPaymentAfter.nameGateway,
        nameBrand: selectedPaymentAfter.brand,
        typePayment: typeAfter,
        paymentItemData: selectedPaymentAfter,
      });
      if (
        selectedPaymentAfter.cardOperator === 100 &&
        (!paymentMoney ||
          parseFloat(total.toFixed(2)) > parseFloat(paymentMoney))
      ) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "O pagamento em dinheiro deve ser maior ou igual ao valor da compra.",
        });
        return;
      }
      orderContext.setChangePayment(
        parseFloat((parseFloat(paymentMoney) - total).toFixed(2))
      );
    } else {
      orderContext.setChangePayment(0);
    }

    orderContext.setPaymentType(payment);
    orderContext.setGatewayId(paymentId);
    setGatewayIdSelected(paymentId);
    setTypePayment(payment);

    orderContext.setChangePayment(0);

    await orderContext.totalValueOrder();
    setLoading(true);
    if (cpfNote === "" || !cpfNote || cpfNote.includes("_")) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um CPF válido na nota",
      });
      setLoading(false);
      return;
    }

    if (!paymentId) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um meio de pagamento",
      });
      setLoading(false);
      return;
    }

    const paymentTypeStorage = await orderContext.getPaymentType();

    if (useCpfNote === 1) {
      orderContext.setCpfInNote(cpfNote);
    } else {
      orderContext.setCpfInNote("");
    }
    orderContext.setIsCpfInNote(useCpfNote);

    orderContext.setPaymentType(payment);
    orderContext.setTotalValue(total)



    await orderContext.synchronizeContextToStorage();

    if (paymentTypeStorage.includes("card")) {
      setLoading(false);
      navigate(`/${pluginspace_id}/card`);
    } else if (
      paymentTypeStorage.includes("pix") ||
      paymentTypeStorage.includes("shipay") ||
      paymentTypeStorage.includes("wallet")
    ) {
      setLoading(false);

      if (pluginspace.type !== "food") {
        navigate(`/${pluginspace_id}/new-order-finalize`);
      } else {
        navigate(`/${pluginspace_id}/order-finalize`);
      }
    } else if (paymentTypeStorage.includes("delivery-payment")) {
      // await generateCodePayPlanDelivery();
      setLoading(false);

      if (pluginspace.type !== "food") {
        navigate(`/${pluginspace_id}/new-order-finalize`);
      } else {
        navigate(`/${pluginspace_id}/order-finalize`);
      }
    }
  }

  async function validateCart(timeCart: string): Promise<{
    valid: boolean;
    msg: string;
  }> {
    try {
      let valid = false;
      const configLocal = await getAppConfig();
      const pg = await getThisPluginspace();

      const gtmValue =
        !pg || !pg?.gmt?.split(":")[0] ? -3 : parseInt(pg.gmt.split(":")[0]);

      const carrinhoDataCriacao = moment
        .utc(timeCart)
        .utcOffset(gtmValue)
        .seconds(0);
      const now = moment().utcOffset(gtmValue).seconds(0); // Data e hora atuais ajustadas para o GMT

      const hour = configLocal
        ? configLocal.content.pdv.sellerCartExpirationTime.split(":")[0]
        : "2";
      const minute = configLocal
        ? configLocal?.content.pdv.sellerCartExpirationTime.split(":")[1]
        : "0";

      const validTimeCart = carrinhoDataCriacao
        .clone()
        .add(parseInt(hour), "hours")
        .add(parseInt(minute), "minutes");

      valid = validTimeCart.isAfter(now) || validTimeCart.isSame(now, "second");
      const timeDifference = now.diff(validTimeCart, "minutes");
      const hours = Math.floor(timeDifference / 60);
      const minutes = timeDifference % 60;

      let msg = "";

      if (hours && minutes) {
        msg += `${hours} hora(s) e ${minutes} minuto(s) `;
      } else if (minutes) {
        msg += `${minutes} minuto(s) `;
      }

      return {
        valid: valid,
        msg: msg,
      };
    } catch (er) {
      return {
        valid: false,
        msg: ``,
      };
    }
  }

  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];

        const isValid = await validateCart(order.created);
        if (!isValid || !isValid.valid) {
          let text =
            "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor";

          if (isValid && isValid.msg) {
            text = `O carrinho do vendedor expirou por ${isValid.msg}. Favor entrar em contato com o seu vendedor.`;
          }

          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: text,
          }).then(() => navigate(`/${pluginspace_id}/category`));
          return;
        }

        if (order.status != "open") {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho já utilizado",
            text: "O carrinho do vendedor já foi utilizado. Favor entrar em contato com o seu vendedor",
          }).then(() => navigate(`/${pluginspace_id}/category`));
          return;
        }

        orderContext.setGuidCart(guid);
        const customerCart = response.data.data[0];
        const adress = customerCart.jsonCart.address;
        setOrderAddress(adress);

        orderContext.setGuidCartPaymentOrder(true);

        orderContext.changeCustomerDocument(customerCart.cpfCustomer);
        orderContext.setFreight(customerCart.jsonCart.freight);
        orderContext.setType(customerCart.jsonCart.type);
        if (customerCart && customerCart.cpfSeller) {
          orderContext.setSellerCpfCnpj(response.data.data[0].cpfSeller);
        }
        orderContext.changeCustomerDocument(customerCart.cpfCustomer);
        setCpfNote(cpfMask(customerCart.cpfCustomer));
        orderContext.setOrderAddress(adress);
        const productsCart = customerCart.jsonCart.products.map(
          (product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: customerCart.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          }
        );

        await orderContext.changeOrderByGuidCart(productsCart, orderContext);

        const totalValue = await saveTotalandDiscount(productsCart);
        await findCustomer(customerCart.cpfCustomer);

        setTotal(totalValue + parseFloat(customerCart.jsonCart.freight));

        const locationIdSend = await findLocationId(customerCart.jsonCart.type);
        await getPaymentMethods(locationIdSend ? locationIdSend : 0);
        await orderContext.setShouldUpdadeCustomerCart(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function saveTotalandDiscount(products: any[]) {
    let newTotal = 0;
    let newTotalWithoutDiscount = 0;
    products.map((prod) => {
      if (
        prod.unitPrice === prod.promotionalPrice ||
        prod.promotionalPrice === 0
      ) {
        newTotal += prod.quantity * prod.unitPrice;
      } else {
        newTotal += prod.quantity * prod.promotionalPrice;
      }
      newTotalWithoutDiscount += prod.quantity * prod.unitPrice;
      if (prod.additionals) {
        prod.additionals.map((additional: any) => {
          newTotalWithoutDiscount +=
            prod.quantity * (additional.quantity * additional.price);
          newTotal += prod.quantity * (additional.quantity * additional.price);
        });
      }
      if (prod.fractions && prod.fractions.length > 0) {
        let priceFractional = calculatePriceFractionalToProduct(prod);

        newTotalWithoutDiscount += prod.quantity * priceFractional;
        newTotal += prod.quantity * priceFractional;
      }
      return prod;
    });

    orderContext.setTotalValue(newTotal);
    orderContext.setTotalValueWithoutDiscount(newTotalWithoutDiscount);

    return newTotal;
  }

  async function findCustomer(documento: string) {
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(documento);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerRes = response.data.data[0];
          setCustomer({
            name: customerRes.name,
            cpf: cpfMask(customerRes.cpf),
          });
          let customerResponse: CustomerType = {
            id:
              customerRes.id || customerRes.id === 0
                ? customerRes.id
                : customerRes.dados.id,
            name: customerRes.name,
            email: customerRes.email,
            cpf: customerRes.cpf,
            birthdate: customerRes.birthDate,
            wppNotification: customerRes.optinWhatsapp,
            acceptTermDate:
              customerRes.lgpdDataAceiteCarta ||
                customerRes.lgpdDataAceiteCarta === ""
                ? customerRes.lgpdDataAceiteCarta
                : customerRes.dados.lgpdDataAceiteCarta,
            gender: customerRes.gender,
            telephone: customerRes.customerPhones[0]
              ? customerRes.customerPhones[0].numberPhone
              : "",
            cep: customerRes.customerAddresses[0].zipCode,
            address: customerRes.customerAddresses[0].street,
            district: customerRes.customerAddresses[0].district,
            city: customerRes.customerAddresses[0].city,
            state: customerRes.customerAddresses[0].state,
            number: customerRes.customerAddresses[0].number,
            complement: customerRes.customerAddresses[0].extra,
            ibge: customerRes.customerAddresses[0].ibgeCode,
            inscEstadual: customerRes.customerAddresses[0].zipCode,
          };
          if (response.data.dados && response.data.dados.customerId) {
            customerResponse.customerWinthor = response.data.dados.customerId;
          }
          orderContext.setCustomer(customerResponse);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function findLocationId(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == type
        );
        orderContext.setLocationId(location.id);
        return location ? location.id : 0;
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao encontrar loja",
        });
        return 0;
      });
  }

  async function changePayment(payment: string, paymentId: number) {
    orderContext.setPaymentType(payment);
    orderContext.setGatewayId(paymentId);
    setGatewayIdSelected(paymentId);
    setTypePayment(payment);
  }

  function cardIcon(cardBrand: string) {
    switch (cardBrand) {
      case "visa":
        return (
          <img
            src={visaLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );

      case "mastercard":
        return (
          <img
            src={masterCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "americanexpress":
        return (
          <img
            src={americaExpressLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "elo":
        return (
          <img
            src={eloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "hipercard":
        return (
          <img
            src={hiperCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "maestro":
        return (
          <img
            src={maestroLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "rede":
        return (
          <img
            src={redeLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "ticket":
        return (
          <img
            src={ticketLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "alelo":
        return (
          <img
            src={aleloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "others":
        return (
          <>
            <svg
              width="16"
              height="16"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49.4863 20.9105C49.4863 19.0549 48.4396 17.4267 46.9118 16.5915C47.0757 16.1104 47.1708 15.6029 47.1708 15.0743C47.1708 13.832 46.6898 12.6689 45.8175 11.7967L35.3768 1.35597C33.5688 -0.45199 30.6296 -0.45199 28.8216 1.35597L21.0241 9.15346C11.5297 9.22218 2.51634 10.2425 0.481065 18.0241C0.142734 18.8329 0 19.832 0 20.9052V44.599C0 47.3004 2.20973 49.5101 4.91109 49.5101H44.5752C47.2766 49.5101 49.4863 47.3004 49.4863 44.599V37.6632H31.1582C28.4569 37.6632 26.2471 35.4535 26.2471 32.7521C26.2471 30.0507 28.4569 27.841 31.1582 27.841H49.4863V20.9052V20.9105ZM17.8258 12.3465L14.1782 15.9941H5.00096C7.09439 13.7421 11.1174 12.6478 17.8258 12.3465ZM18.6347 15.9941L31.0419 3.58685C31.6181 3.01062 32.5644 3.00534 33.1406 3.58685L43.5813 14.0275C43.8615 14.3077 44.0148 14.6778 44.0148 15.0743C44.0148 15.4179 43.8985 15.7351 43.6924 15.9941H18.64H18.6347Z"
                fill="#1B1B1B"
              />
              <path
                d="M27.7803 32.8365C27.7803 34.8348 29.4032 36.4578 31.4015 36.4578C33.3998 36.4578 35.0227 34.8348 35.0227 32.8365C35.0227 30.8383 33.3998 29.2153 31.4015 29.2153C29.4032 29.2153 27.7803 30.8383 27.7803 32.8365Z"
                fill="#1B1B1B"
              />
            </svg>
          </>
        );
      default:
        return (
          <>
            <div
              style={{
                width: "32px",
                height: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <i
                className="fa fa-credit-card"
                style={{
                  color: "#3C9EE5",
                }}
              />
            </div>
          </>
        );
    }
  }

  function chooseMethodPaymentDefault() {
    if (havePaymentOnline) {
      setMomentType("before");
    } else if (paymentsAfter && paymentsAfter.length > 0) {
      setMomentType("after");
    }
  }

  /* Funcoes utilizadas para aplicar desconto no meio do pagamento selecionado */
  //verificação do motor de promoção ninegrid


  async function verifyNinegridProm() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 107,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setNinegridMotorAble(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function applyDiscountNinegrid(
    apply: boolean,
    type: string,
    value: string,
    applyed: boolean
  ) {
    try {
      if (applyed) return;

      const totalValues = await orderContext.totalValueOrder();
      const originalTotal = totalValues.totalWithoutDiscount;

      if (apply) {

        const { newTotal, totalDiscount } = calculateDiscount(
          type,
          value,
          totalValues.total,
          originalTotal
        );

        if (newTotal < 0) {
          handleInvalidDiscount(totalValues.total);
          return;
        }

        // Apply the discount
        setTotal(newTotal + freight);
        setPaymentDiscount({ typeDiscount: type, discountValue: value });
        discountContext.setPaymentDiscount(type, totalDiscount, parseFloat(value))

        await orderContext.synchronizeContextToStorage();
      } else {
        // Remove the discount
        discountContext.setPaymentDiscount('', 0, 0)
        await resetDiscount(totalValues.total);
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    }
  }

  // Helper function to calculate the discount
  function calculateDiscount(
    type: string,
    value: string,
    total: number,
    totalWithoutDiscount: number
  ) {
    let newTotal = 0;
    let totalDiscount = 0;

    if (type === "percentage") {
      totalDiscount = (totalWithoutDiscount * parseFloat(value)) / 100;
    } else {
      totalDiscount = parseFloat(value);
    }

    newTotal = total - totalDiscount;

    return { newTotal, totalDiscount };
  }

  // Handle invalid discount scenarios
  async function handleInvalidDiscount(originalTotal: number) {
    openToast(
      "warning",
      "O valor do desconto não pode ser maior que o total da compra",
      5000
    );
    await resetDiscount(originalTotal);
  }

  // Reset discount to its original state
  async function resetDiscount(originalTotal: number) {
    await removePaymentDiscountFunction();
    setTotal(originalTotal + freight);

    setPaymentDiscount(null);
    await orderContext.synchronizeContextToStorage();
  }

  useEffect(() => {
    chooseMethodPaymentDefault();
  }, [havePaymentOnline, paymentsAfter]);


  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (paymentSelected && selectedPaymentAfter?.typePay !== `Money`) {
      if (
        typePayment === "delivery-payment" &&
        (typeAfter === "card" || typeAfter === "others")
      ) {
        setOpenModalInstallment(true);
        return;
      }
      choosePayment();
    }

  }, [paymentSelected, selectedPaymentAfter]);



  return (
    <div className={styles.order_info}>
      <div className={styles.content_order_info}>
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.order_info_body}>
            <div className={styles.order_info_body_content}>
              <CheckoutOrder position={3} name={"Forma de pagamento"} />
              <SumaryOrder page="pagamento" />

              <div className={styles.payment_tab}>
                <div className={styles.payment_tab_options}>
                  {havePaymentOnline && (
                    <div
                      className={styles.payment_tab_option}
                      onClick={() => {
                        setMomentType("before");
                      }}
                      style={{
                        opacity: momentType !== "before" ? "50%" : "100%",
                      }}
                    >
                      <span>Pague antecipado</span>
                    </div>
                  )}

                  {paymentsAfter &&
                    paymentsAfter.length > 0 &&
                    !isCounter &&
                    !orderAddress?.frenet &&
                    paymentMethods.map((payment) => {
                      if (
                        payment.id === config?.content.pdv.gatewayDeliveryId &&
                        payment.plugintemplateId.id === 44
                      ) {
                        return (
                          <div
                            className={styles.payment_tab_option}
                            onClick={() => {
                              changePayment("delivery-payment", payment.id);
                              setMomentType("after");
                            }}
                            style={{
                              opacity: momentType === "before" ? "50%" : "100%",
                            }}
                          >
                            {(nameTabeWithdrawal && (
                              <span>{nameTabeWithdrawal}</span>
                            )) || <span>Pague ao receber</span>}
                          </div>
                        );
                      }
                    })}
                </div>
                {/*	Pagamentos Antecipados*/}

                {momentType === "before" && (
                  <div className={styles.payment_tab_moment_type}>
                    {paymentMethods.map((payment) => {
                      if (payment.id === config?.content.pdv.gatewayId) {
                        switch (payment.plugintemplateId.id) {
                          case 25:
                            let ableCard = false;

                            Object.entries(payment.content).forEach(
                              (config) => {
                                if (
                                  config[0].replace(/\W/gi, "") ===
                                  "ableCard" &&
                                  config[1] === "1"
                                ) {
                                  ableCard = true;
                                }
                              }
                            );
                            if (
                              ableCard &&
                              payment.id === config?.content.pdv.gatewayPixId &&
                              wallets
                            ) {
                              return (
                                <>
                                  <div
                                    className={
                                      gatewayIdSelected === payment.id &&
                                        typePayment === "totvs-card"
                                        ? styles.type_method_selected
                                        : styles.type_method
                                    }
                                    onClick={async () => {

                                      await applyDiscountNinegrid(
                                        payment.content["discountCardAble"],
                                        payment.content["discountCardType"] ??
                                        "percentage",
                                        payment.content["discountCardValue"],
                                        gatewayIdSelected === payment.id &&
                                        typePayment === "totvs-card"
                                      );
                                      changePayment("totvs-card", payment.id);
                                      chooseBeforePayment("totvs-card", payment.id)
                                    }}
                                  >
                                    <i
                                      className="fa fa-credit-card"
                                      style={{
                                        color: "#3C9EE5",
                                        width: "16px",
                                        height: "auto",
                                      }}
                                    />
                                    <p>Cartão de crédito</p>
                                    {payment.content &&
                                      payment.content["discountCardAble"] && (
                                        <CardPaymentDiscount
                                          discountType={
                                            payment.content[
                                            "discountCardType"
                                            ] ?? "percentage"
                                          }
                                          discountValue={
                                            payment.content["discountCardValue"]
                                          }
                                        />
                                      )}
                                  </div>
                                  {wallets.map((wallet: WalletType) => (
                                    <div
                                      className={
                                        gatewayIdSelected === payment.id &&
                                          typePayment === `${wallet.code}-wallet`
                                          ? styles.type_method_selected
                                          : styles.type_method
                                      }
                                      onClick={async () => {

                                        await applyDiscountNinegrid(
                                          payment.content["discountPixAble"],
                                          payment.content["discountPixType"] ??
                                          "percentage",
                                          payment.content["discountPixValue"],
                                          gatewayIdSelected === payment.id &&
                                          typePayment ===
                                          `${wallet.code}-wallet`
                                        );

                                        changePayment(
                                          `${wallet.code}-wallet`,
                                          payment.id
                                        );
                                      }}
                                    >
                                      <img
                                        src={wallet.logo}
                                        alt={wallet.name}
                                      />
                                      <p>{wallet.name}</p>
                                      {payment.content &&
                                        payment.content["discountPixAble"] && (
                                          <CardPaymentDiscount
                                            discountType={
                                              payment.content[
                                              "discountPixType"
                                              ] ?? "percentage"
                                            }
                                            discountValue={
                                              payment.content[
                                              "discountPixValue"
                                              ]
                                            }
                                          />
                                        )}
                                    </div>
                                  ))}
                                </>
                              );
                            } else if (
                              payment.id === config?.content.pdv.gatewayPixId &&
                              wallets &&
                              !ableCard
                            ) {
                              return (
                                <>
                                  {wallets.map((wallet: WalletType) => (
                                    <div
                                      className={
                                        gatewayIdSelected === payment.id &&
                                          typePayment === `${wallet.code}-wallet`
                                          ? styles.type_method_selected
                                          : styles.type_method
                                      }
                                      onClick={async () => {

                                        await applyDiscountNinegrid(
                                          payment.content["discountPixAble"],
                                          payment.content["discountPixType"] ??
                                          "percentage",
                                          payment.content["discountPixValue"],
                                          gatewayIdSelected === payment.id &&
                                          typePayment ===
                                          `${wallet.code}-wallet`
                                        );
                                        changePayment(
                                          `${wallet.code}-wallet`,
                                          payment.id
                                        );
                                        chooseBeforePayment(`${wallet.code}-wallet`, payment.id)
                                      }}
                                    >
                                      <img
                                        src={wallet.logo}
                                        alt={wallet.name}
                                      />
                                      <p>{wallet.name}</p>
                                      {payment.content &&
                                        payment.content["discountPixAble"] && (
                                          <CardPaymentDiscount
                                            discountType={
                                              payment.content[
                                              "discountPixType"
                                              ] ?? "percentage"
                                            }
                                            discountValue={
                                              payment.content[
                                              "discountPixValue"
                                              ]
                                            }
                                          />
                                        )}
                                    </div>
                                  ))}
                                </>
                              );
                            } else if (ableCard) {
                              return (
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                      typePayment === "totvs-card"
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={async () => {

                                    await applyDiscountNinegrid(
                                      payment.content["discountCardAble"],
                                      payment.content["discountCardType"] ??
                                      "percentage",
                                      payment.content["discountCardValue"],
                                      gatewayIdSelected === payment.id &&
                                      typePayment === "totvs-card"
                                    );
                                    changePayment("totvs-card", payment.id);
                                    chooseBeforePayment(`totvs-card`, payment.id)
                                  }}
                                >
                                  <i
                                    className="fa fa-credit-card"
                                    style={{
                                      color: "#3C9EE5",
                                      width: "16px",
                                      height: "auto",
                                    }}
                                  />
                                  <p>Cartão de crédito</p>
                                  {payment.content &&
                                    payment.content["discountCardAble"] && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.content["discountCardType"] ??
                                          "percentage"
                                        }
                                        discountValue={
                                          payment.content["discountCardValue"]
                                        }
                                      />
                                    )}
                                </div>
                              );
                            } else return <></>;
                          case 12:
                            return (
                              <div
                                className={
                                  gatewayIdSelected === payment.id &&
                                    typePayment === "esitef-card"
                                    ? styles.type_method_selected
                                    : styles.type_method
                                }
                                onClick={async () => {

                                  await applyDiscountNinegrid(
                                    payment.content["discountCardAble"],
                                    payment.content["discountCardType"] ??
                                    "percentage",
                                    payment.content["discountCardValue"],
                                    gatewayIdSelected === payment.id &&
                                    typePayment === "esitef-card"
                                  );
                                  changePayment("esitef-card", payment.id);
                                  chooseBeforePayment("esitef-card", payment.id)
                                }}
                              >
                                <i
                                  className="fa fa-credit-card"
                                  style={{
                                    color: "#3C9EE5",
                                    width: "16px",
                                    height: "auto",
                                  }}
                                />
                                <p>Cartão de crédito</p>
                                {payment.content &&
                                  payment.content["discountCardAble"] && (
                                    <CardPaymentDiscount
                                      discountType={
                                        payment.content["discountCardType"] ??
                                        "percentage"
                                      }
                                      discountValue={
                                        payment.content["discountCardValue"]
                                      }
                                    />
                                  )}
                              </div>
                            );
                          case 20:
                            return (
                              <>
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                      typePayment === "cielo-card"
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={async () => {

                                    await applyDiscountNinegrid(
                                      payment.content["discountCardAble"],
                                      payment.content["discountCardType"] ??
                                      "percentage",
                                      payment.content["discountCardValue"],
                                      gatewayIdSelected === payment.id &&
                                      typePayment === "cielo-card"
                                    );
                                    changePayment("cielo-card", payment.id);
                                    chooseBeforePayment("cielo-card", payment.id)
                                  }}
                                >
                                  <i
                                    className="fa fa-credit-card"
                                    style={{
                                      color: "#3C9EE5",
                                      width: "16px",
                                      height: "auto",
                                    }}
                                  />
                                  <p>Cartão de crédito</p>
                                  {payment.content &&
                                    payment.content["discountCardAble"] && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.content["discountCardType"] ??
                                          "percentage"
                                        }
                                        discountValue={
                                          payment.content["discountCardValue"]
                                        }
                                      />
                                    )}
                                </div>
                              </>
                            );
                          case 10:
                            if (
                              payment.id === config?.content.pdv.gatewayPixId &&
                              payment.content.pix === "1"
                            ) {
                              return (
                                <>
                                  <div
                                    className={
                                      gatewayIdSelected === payment.id &&
                                        typePayment === "pagseguro-card"
                                        ? styles.type_method_selected
                                        : styles.type_method
                                    }
                                    onClick={async () => {

                                      await applyDiscountNinegrid(
                                        payment.content["discountCardAble"],
                                        payment.content["discountCardType"] ??
                                        "percentage",
                                        payment.content["discountCardValue"],
                                        gatewayIdSelected === payment.id &&
                                        typePayment === "pagseguro-card"
                                      );
                                      changePayment(
                                        "pagseguro-card",
                                        payment.id
                                      );
                                      chooseBeforePayment(`pagseguro-card`, payment.id)
                                    }}
                                  >
                                    <i
                                      className="fa fa-credit-card"
                                      style={{
                                        color: "#3C9EE5",
                                        width: "16px",
                                        height: "auto",
                                      }}
                                    />
                                    <p>Cartão de crédito</p>
                                    {payment.content &&
                                      payment.content["discountCardAble"] && (
                                        <CardPaymentDiscount
                                          discountType={
                                            payment.content[
                                            "discountCardType"
                                            ] ?? "percentage"
                                          }
                                          discountValue={
                                            payment.content["discountCardValue"]
                                          }
                                        />
                                      )}
                                  </div>
                                  <div
                                    className={
                                      gatewayIdSelected === payment.id &&
                                        typePayment === "pagseguro-pix"
                                        ? styles.type_method_selected
                                        : styles.type_method
                                    }
                                    onClick={async () => {

                                      await applyDiscountNinegrid(
                                        payment.content["discountPixAble"],
                                        payment.content["discountPixType"] ??
                                        "percentage",
                                        payment.content["discountPixValue"],
                                        gatewayIdSelected === payment.id &&
                                        typePayment === "pagseguro-pix"
                                      );
                                      changePayment(
                                        "pagseguro-pix",
                                        payment.id
                                      );
                                      chooseBeforePayment(`pagseguro-pix`, payment.id)
                                    }}
                                  >
                                    <img src={PixImg} alt="Pix" />
                                    <p>Pix</p>
                                    {payment.content &&
                                      payment.content["discountPixAble"] && (
                                        <CardPaymentDiscount
                                          discountType={
                                            payment.content[
                                            "discountPixType"
                                            ] ?? "percentage"
                                          }
                                          discountValue={
                                            payment.content["discountPixValue"]
                                          }
                                        />
                                      )}
                                  </div>
                                </>
                              );
                            } else {
                              return (
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                      typePayment === "pagseguro-card"
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={async () => {

                                    await applyDiscountNinegrid(
                                      payment.content["discountCardAble"],
                                      payment.content["discountCardType"] ??
                                      "percentage",
                                      payment.content["discountCardValue"],
                                      gatewayIdSelected === payment.id &&
                                      typePayment === "pagseguro-card"
                                    );
                                    changePayment("pagseguro-card", payment.id);
                                    chooseBeforePayment(`pagseguro-card`, payment.id)
                                  }}
                                >
                                  <i
                                    className="fa fa-credit-card"
                                    style={{
                                      color: "#3C9EE5",
                                      width: "16px",
                                      height: "auto",
                                    }}
                                  />
                                  <p>Cartão de crédito</p>
                                  {payment.content &&
                                    payment.content["discountCardAble"] && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.content["discountCardType"] ??
                                          "percentage"
                                        }
                                        discountValue={
                                          payment.content["discountCardValue"]
                                        }
                                      />
                                    )}
                                </div>
                              );
                            }
                          case 47:
                            return (
                              <div
                                className={
                                  gatewayIdSelected === payment.id &&
                                    typePayment === "rede-card"
                                    ? styles.type_method_selected
                                    : styles.type_method
                                }
                                onClick={async () => {
                                  await applyDiscountNinegrid(
                                    payment.content["discountCardAble"],
                                    payment.content["discountCardType"] ??
                                    "percentage",
                                    payment.content["discountCardValue"],
                                    gatewayIdSelected === payment.id &&
                                    typePayment === "rede-card"
                                  );
                                  changePayment("rede-card", payment.id);
                                  chooseBeforePayment(`rede-card`, payment.id)
                                }}
                              >
                                <i
                                  className="fa fa-credit-card"
                                  style={{
                                    color: "#3C9EE5",
                                    width: "16px",
                                    height: "auto",
                                  }}
                                />
                                <p>Cartão de crédito</p>
                                {payment.content &&
                                  payment.content["discountCardAble"] && (
                                    <CardPaymentDiscount
                                      discountType={
                                        payment.content["discountCardType"] ??
                                        "percentage"
                                      }
                                      discountValue={
                                        payment.content["discountCardValue"]
                                      }
                                    />
                                  )}
                              </div>
                            );
                        }
                      }
                      if (payment.id === config?.content.pdv.gatewayPixId) {
                        switch (payment.plugintemplateId.id) {
                          case 10:
                            if (payment.content.pix === "1") {
                              return (
                                <>
                                  <div
                                    className={
                                      gatewayIdSelected === payment.id &&
                                        typePayment === "pagseguro-pix"
                                        ? styles.type_method_selected
                                        : styles.type_method
                                    }
                                    onClick={async () => {

                                      await applyDiscountNinegrid(
                                        payment.content["discountPixAble"],
                                        payment.content["discountPixType"] ??
                                        "percentage",
                                        payment.content["discountPixValue"],
                                        gatewayIdSelected === payment.id &&
                                        typePayment === "pagseguro-pix"
                                      );
                                      changePayment(
                                        "pagseguro-pix",
                                        payment.id
                                      );
                                      chooseBeforePayment(`pagseguro-pix`, payment.id)
                                    }}
                                  >
                                    <img src={PixImg} alt="Pix" />
                                    <p>Pix</p>
                                    {payment.content &&
                                      payment.content["discountPixAble"] && (
                                        <CardPaymentDiscount
                                          discountType={
                                            payment.content[
                                            "discountPixType"
                                            ] ?? "percentage"
                                          }
                                          discountValue={
                                            payment.content["discountPixValue"]
                                          }
                                        />
                                      )}
                                  </div>
                                </>
                              );
                            } else return <></>;
                          case 25:
                            if (wallets) {
                              return wallets.map((wallet: WalletType) => (
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                      typePayment === `${wallet.code}-wallet`
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={async () => {

                                    await applyDiscountNinegrid(
                                      payment.content["discountPixAble"],
                                      payment.content["discountPixType"] ??
                                      "percentage",
                                      payment.content["discountPixValue"],
                                      gatewayIdSelected === payment.id &&
                                      typePayment === `${wallet.code}-wallet`
                                    );
                                    changePayment(
                                      `${wallet.code}-wallet`,
                                      payment.id
                                    );
                                    chooseBeforePayment(`${wallet.code}-wallet`, payment.id)
                                  }}
                                >
                                  <img src={wallet.logo} alt={wallet.name} />
                                  <p>{wallet.name}</p>
                                  {payment.content &&
                                    payment.content["discountPixAble"] && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.content["discountPixType"] ??
                                          "percentage"
                                        }
                                        discountValue={
                                          payment.content["discountPixValue"]
                                        }
                                      />
                                    )}
                                </div>
                              ));
                            }
                            break;
                        }
                      }
                    })}
                  </div>
                )}
                {momentType === "after" && (
                  <div className={styles.payment_tab_moment_type}>
                    {paymentsAfter.find(
                      (payment) =>
                        payment.typePay === "Credit" &&
                        payment.cardOperator !== 100 && //Dinheiro
                        payment.cardOperator !== 99 && //PIX
                        payment.cardOperator !== 23 && //Sodex
                        payment.cardOperator !== 26 && //VR
                        payment.cardOperator !== 10 && //Alelo
                        payment.cardOperator !== 27 //Ticket
                    ) &&
                      paymentsAfterAble.ableCredit && (
                        <>
                          <div className={styles.payment_card_option}>
                            <span>Cartão de crédito</span>
                          </div>
                          {paymentsAfter
                            .filter(
                              (payment) =>
                                payment.typePay === "Credit" &&
                                payment.cardOperator !== 100 && //Dinheiro
                                payment.cardOperator !== 99 && //PIX
                                payment.cardOperator !== 23 && //Sodex
                                payment.cardOperator !== 26 && //VR
                                payment.cardOperator !== 10 && //Alelo
                                payment.cardOperator !== 27 //Ticket
                            )
                            .map((payment) => (
                              <div
                                className={
                                  payment.id === selectedPaymentAfter?.id
                                    ? styles.type_method_selected
                                    : styles.type_method
                                }
                                onClick={async () => {
                                  await applyDiscountNinegrid(
                                    payment.ableDiscount,
                                    payment.typeDiscount ?? "percentage",
                                    payment.discountValue,
                                    payment.id === selectedPaymentAfter?.id
                                  );


                                  changePayment(
                                    "delivery-payment",
                                    payment.pluginconfigId
                                  );
                                  setTypeAfter("card");

                                  setSelectedPaymentAfter(payment);


                                  setPaymentSelected(payment);
                                }}
                              >
                                {cardIcon(payment.brand.toLowerCase())}
                                <p>{payment.brand}</p>
                                {payment.ableDiscount && (
                                  <CardPaymentDiscount
                                    discountType={
                                      payment.typeDiscount ?? "percentage"
                                    }
                                    discountValue={payment.discountValue}
                                  />
                                )}
                              </div>
                            ))}
                        </>
                      )}
                    {paymentsAfter.find(
                      (payment) =>
                        payment.typePay === "Debit" &&
                        payment.cardOperator !== 100 && //Dinheiro
                        payment.cardOperator !== 99 && //PIX
                        payment.cardOperator !== 23 && //Sodex
                        payment.cardOperator !== 26 && //VR
                        payment.cardOperator !== 10 && //Alelo
                        payment.cardOperator !== 27 //Ticket
                    ) &&
                      paymentsAfterAble.ableDebit && (
                        <>
                          <div className={styles.payment_card_option}>
                            <span>Cartão de débito</span>
                          </div>
                          {paymentsAfter
                            .filter(
                              (payment) =>
                                payment.typePay === "Debit" &&
                                payment.cardOperator !== 100 && //Dinheiro
                                payment.cardOperator !== 99 && //PIX
                                payment.cardOperator !== 23 && //Sodex
                                payment.cardOperator !== 26 && //VR
                                payment.cardOperator !== 10 && //Alelo
                                payment.cardOperator !== 27 //Ticket
                            )
                            .map((payment) => (
                              <div
                                className={
                                  payment.id === selectedPaymentAfter?.id
                                    ? styles.type_method_selected
                                    : styles.type_method
                                }
                                onClick={async () => {

                                  await applyDiscountNinegrid(
                                    payment.ableDiscount,
                                    payment.typeDiscount ?? "percentage",
                                    payment.discountValue,
                                    payment.id === selectedPaymentAfter?.id
                                  );

                                  changePayment(
                                    "delivery-payment",
                                    payment.pluginconfigId
                                  );
                                  setTypeAfter("debit-card");
                                  setSelectedPaymentAfter(payment);
                                  setPaymentSelected(payment);
                                }}
                              >
                                {cardIcon(payment.brand.toLowerCase())}
                                <p>{payment.brand}</p>
                                {payment.ableDiscount && (
                                  <CardPaymentDiscount
                                    discountType={
                                      payment.typeDiscount ?? "percentage"
                                    }
                                    discountValue={payment.discountValue}
                                  />
                                )}
                              </div>
                            ))}
                        </>
                      )}
                    {paymentsAfter.find(
                      (payment) =>
                        payment.typePay === "Credit" &&
                        (payment.cardOperator == 23 || //Sodex
                          payment.cardOperator == 26 || //VR
                          payment.cardOperator == 10 || //Alelo
                          payment.cardOperator == 27) //Ticket
                    ) &&
                      paymentsAfterAble.ableAlimentation && (
                        <>
                          <div className={styles.payment_card_option}>
                            <span>Alimentação</span>
                          </div>
                          {paymentsAfter
                            .filter(
                              (payment) =>
                                payment.typePay === "Credit" &&
                                (payment.cardOperator == 23 || //Sodex
                                  payment.cardOperator == 26 || //VR
                                  payment.cardOperator == 10 || //Alelo
                                  payment.cardOperator == 27) //Ticket
                            )
                            .map((payment) => (
                              <>
                                <div
                                  className={
                                    payment.id === selectedPaymentAfter?.id
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={async () => {

                                    await applyDiscountNinegrid(
                                      payment.ableDiscount,
                                      payment.typeDiscount ?? "percentage",
                                      payment.discountValue,
                                      payment.id === selectedPaymentAfter?.id
                                    );

                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId
                                    );
                                    setTypeAfter("food");
                                    setSelectedPaymentAfter(payment);
                                  }
                                  }
                                >
                                  {cardIcon(payment.brand.toLowerCase())}
                                  <p>{payment.brand}</p>
                                  {payment.ableDiscount && (
                                    <CardPaymentDiscount
                                      discountType={
                                        payment.typeDiscount ?? "percentage"
                                      }
                                      discountValue={payment.discountValue}
                                    />
                                  )}
                                </div>
                              </>
                            ))}
                        </>
                      )}
                    {paymentsAfterAble.ablePix &&
                      paymentsAfter
                        .filter((payment) => payment.cardOperator === 99)
                        .map((payment) => (
                          <>
                            <div className={styles.payment_card_option}>
                              <span>Pix</span>
                            </div>
                            <div
                              className={
                                typeAfter === "pix"
                                  ? styles.type_method_selected
                                  : styles.type_method
                              }
                              onClick={async () => {
                                await applyDiscountNinegrid(
                                  payment.ableDiscount,
                                  payment.typeDiscount ?? "percentage",
                                  payment.discountValue,
                                  typeAfter === "pix"
                                );
                                changePayment(
                                  "delivery-payment",
                                  payment.pluginconfigId
                                );
                                setTypeAfter("pix");
                                setSelectedPaymentAfter(payment);

                              }}
                            >
                              <img src={PixImg} alt="Pix" />
                              <p>Pix</p>

                              {payment.ableDiscount && (
                                <CardPaymentDiscount
                                  discountType={
                                    payment.typeDiscount ?? "percentage"
                                  }
                                  discountValue={payment.discountValue}
                                />
                              )}
                            </div>
                          </>
                        ))}
                    {paymentsAfterAble.ableMoney &&
                      paymentsAfter.map((payment) => {
                        if (payment.cardOperator === 100) {
                          return (
                            <>
                              <div className={styles.payment_card_option}>
                                <span>Dinheiro</span>
                              </div>
                              {
                                <>
                                  <div
                                    className={
                                      selectedPaymentAfter &&
                                        selectedPaymentAfter.id === payment.id
                                        ? styles.type_method_selected
                                        : styles.type_method
                                    }
                                    onClick={async () => {
                                      await applyDiscountNinegrid(
                                        payment.ableDiscount,
                                        payment.typeDiscount ?? "percentage",
                                        payment.discountValue,
                                        selectedPaymentAfter !== null &&
                                        selectedPaymentAfter &&
                                        selectedPaymentAfter.id === payment.id
                                      );
                                      setTypeAfter("money");
                                      changePayment(
                                        "delivery-payment",
                                        payment.pluginconfigId
                                      );
                                      setSelectedPaymentAfter(payment);
                                      setPaymentMoney(total.toFixed(2));

                                    }}
                                  >
                                    <i
                                      className="fa fa-money-bill"
                                      style={{ color: "#E19C15" }}
                                    ></i>
                                    <p>Pagamento em dinheiro</p>
                                    {payment.ableDiscount && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.typeDiscount ?? "percentage"
                                        }
                                        discountValue={payment.discountValue}
                                      />
                                    )}
                                  </div>

                                  {typeAfter === "money" && (
                                    <div>
                                      <Switch
                                        change={(value: boolean) => {
                                          setNeedChanges(value);

                                          if (value) {
                                            setPaymentMoney("0");
                                          } else {
                                            setPaymentMoney(total.toFixed(2));
                                          }
                                        }}
                                        value={needChanges}
                                        label="Precisa de troco?"
                                      />
                                    </div>
                                  )}

                                  {needChanges && (
                                    <div className={styles.inputs_change}>
                                      <div
                                        className={styles.input}
                                        style={{ width: "60%" }}
                                      >
                                        <label>Troco para</label>
                                        <Input
                                          inputAttr={{
                                            type: "money",
                                          }}
                                          label={""}
                                          textCenter={true}
                                          placeholder="Pagamento"
                                          value={paymentMoney}
                                          locale="pt-BR"
                                          currency="BRL"
                                          change={(value: string) =>
                                            setPaymentMoney(value)
                                          }
                                          backgroundColor={"#dbdbdb"}
                                        />
                                      </div>
                                      <div
                                        className={`${styles.input} ${styles.disable}`}
                                        style={{ width: "40%" }}
                                      >
                                        <label>Esse será o troco</label>
                                        <div className={styles.money_changes}>
                                          <span>
                                            R${" "}
                                            {parseFloat(paymentMoney) > 0
                                              ? (
                                                parseFloat(paymentMoney) -
                                                total
                                              ).toFixed(2)
                                              : parseFloat(
                                                (0 * -1).toString()
                                              ).toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              }
                            </>
                          );
                        } else {
                          return null;
                        }
                      })}
                    {paymentsAfterAble.ableOthers &&
                      paymentsAfter.find(
                        (payment) => payment.typePay === "Others"
                      ) && (
                        <>
                          <div className={styles.payment_card_option}>
                            <span>Outros</span>
                          </div>
                          {paymentsAfter
                            .filter(
                              (payment) =>
                                payment.typePay === "Others" &&
                                payment.cardOperator !== 100 && //Dinheiro
                                payment.cardOperator !== 99 && //PIX
                                payment.cardOperator !== 23 && //Sodex
                                payment.cardOperator !== 26 && //VR
                                payment.cardOperator !== 10 && //Alelo
                                payment.cardOperator !== 27 //Ticket
                            )
                            .map((payment) => (
                              <div
                                className={
                                  payment.id === selectedPaymentAfter?.id
                                    ? styles.type_method_selected
                                    : styles.type_method
                                }
                                onClick={async () => {
                                  await applyDiscountNinegrid(
                                    payment.ableDiscount,
                                    payment.typeDiscount ?? "percentage",
                                    payment.discountValue,
                                    payment.id === selectedPaymentAfter?.id
                                  );
                                  changePayment(
                                    "delivery-payment",
                                    payment.pluginconfigId
                                  );
                                  setPaymentSelected(payment);
                                  setTypeAfter("others");
                                  setSelectedPaymentAfter(payment);
                                }}
                              >
                                {cardIcon("others".toLowerCase())}
                                <p>{payment.brand}</p>
                                {payment.ableDiscount && (
                                  <CardPaymentDiscount
                                    discountType={
                                      payment.typeDiscount ?? "percentage"
                                    }
                                    discountValue={payment.discountValue}
                                  />
                                )}
                              </div>
                            ))}
                        </>
                      )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {!loading && (
          <ButtonCheckout
            action={() => {
              if (
                typePayment === "delivery-payment" &&
                (typeAfter === "card" || typeAfter === "others")
              ) {
                setOpenModalInstallment(true);
                return;
              }
              choosePayment();
            }}
            label={"Continuar"}
            backgroundColor={
              config?.webappcolor.webappbutton
                ? config.webappcolor.webappbutton
                : "#EAEAEA"
            }
            color={
              config?.webappcolor.fontbutton
                ? config?.webappcolor.fontbutton
                : "#636363"
            }
            marginBottom
          />
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
      {openModalInstallment && (
        <ModalSelectInstallment
          open={openModalInstallment}
          onClose={() => setOpenModalInstallment(false)}
          payments={paymentsAfter}
          paymentSelected={paymentSelected}
          /*Por conta dos descontos colocar aqui */
          total={total - (discountContext.data.couponValue + discountContext.data.paymentDiscountValue)}
          config={config}
          setInstallment={setInstallments}
          setCodePlanSelected={setCodePlanSelected}
          onNext={choosePayment}
        />
      )}
    </div>
  );
};

export { NewChoosePayment };
